// ABOUTME: Market section of the user menu: the tab's markets, the active one selected; off → nothing.
// ABOUTME: Picking another market stores it for this tab and reloads, so everything is refetched.

import { Divider, MenuItem } from '@ds/coolshop';
import ListSubheader from '@mui/material/ListSubheader';
import { useIntl } from 'react-intl';

import { useActiveMarket } from '../hooks/useActiveMarket';
import { useMarketLabel } from '../hooks/useMarketLabel';
import { getMarketSwitcherState } from '../utils/marketSwitcherState';

/** px */
const MENU_MIN_WIDTH = 240;

type MarketMenuSectionProps = {
    /** called on every pick, before a switch reloads the tab: closes the menu */
    onSelect: () => void;
};

export function MarketMenuSection({ onSelect }: MarketMenuSectionProps) {
    const intl = useIntl();
    const { marketContext, allowedMarkets, activeMarketId, switchMarket } = useActiveMarket();
    const { label } = useMarketLabel();
    const state = getMarketSwitcherState(marketContext);

    if (state.kind === 'hidden') return null;

    return (
        <>
            {/* The menu takes its widest child's width: this widens it past the user's name. */}
            <ListSubheader sx={{ minWidth: MENU_MIN_WIDTH }}>{label}</ListSubheader>
            {state.kind === 'empty' ? (
                <MenuItem disabled>
                    {intl.formatMessage(
                        {
                            id: 'market.switcher.none',
                            defaultMessage: 'No {label} available',
                        },
                        { label },
                    )}
                </MenuItem>
            ) : (
                allowedMarkets.map(market => (
                    <MenuItem
                        key={market.id}
                        selected={market.id === state.value}
                        onClick={() => {
                            onSelect();
                            if (market.id !== activeMarketId) switchMarket(market.id);
                        }}
                    >
                        {market.name}
                    </MenuItem>
                ))
            )}
            <Divider />
        </>
    );
}

export default MarketMenuSection;
